
/** Standard document set shared by the No-Coding agents. */
export const DOC_SET = '.pdf,.docx,.md,.txt,.csv,.xlsx,.ods,.json';
/** knowledge also accepts web pages for RAG ingestion. */
export const KNOWLEDGE_SET = `${DOC_SET},.html,.htm`;

const DOC_MAX_SIZE = 100;
const CODING_MAX_SIZE = 200;

export const UPLOAD_CONFIGS = {
  MD_FILES: {
    accept: DOC_SET,
    maxSize: DOC_MAX_SIZE,
    multiple: true,
    title: 'FILE_UPLOAD_POPOVER.TITLE_MD',
    subtitle: 'FILE_UPLOAD_POPOVER.SUBTITLE_MD',
    description: 'FILE_UPLOAD_POPOVER.DESC',
    fileTypes: `(${DOC_SET})`
  },
  UNIT_TESTS: {
    accept: '.zip',
    maxSize: CODING_MAX_SIZE,
    multiple: false,
    title: 'FILE_UPLOAD_POPOVER.TITLE_UNIT',
    subtitle: 'FILE_UPLOAD_POPOVER.SUBTITLE_UNIT',
    description: 'FILE_UPLOAD_POPOVER.DESC',
    fileTypes: '(.zip)'
  },
  TEMPLATE_FILES: {
    accept: '.pdf,.docx,.md',
    maxSize: DOC_MAX_SIZE,
    multiple: false,
    title: 'FILE_UPLOAD_POPOVER.TITLE',
    subtitle: '',
    description: 'FILE_UPLOAD_POPOVER.DESC',
    fileTypes: '(.pdf,.docx,.md)'
  },
  KNOWLEDGE: {
    accept: KNOWLEDGE_SET,
    maxSize: DOC_MAX_SIZE,
    multiple: true,
    title: 'FILE_UPLOAD_POPOVER.TITLE_KNOWLEDGE',
    subtitle: 'FILE_UPLOAD_POPOVER.SUBTITLE_KNOWLEDGE',
    description: 'FILE_UPLOAD_POPOVER.DESC_KNOWLEDGE',
    fileTypes: `(${KNOWLEDGE_SET})`
  },
  REFACTOR: {
    accept: '.zip',
    maxSize: CODING_MAX_SIZE,
    multiple: false,
    title: 'FILE_UPLOAD_POPOVER.TITLE_UNIT',
    subtitle: 'FILE_UPLOAD_POPOVER.SUBTITLE_UNIT',
    description: 'FILE_UPLOAD_POPOVER.DESC',
    fileTypes: '(.zip)'
  },
  INCIDENTS: {
    accept: DOC_SET,
    maxSize: DOC_MAX_SIZE,
    multiple: true,
    title: 'FILE_UPLOAD_POPOVER.TITLE_INCIDENTS',
    subtitle: 'FILE_UPLOAD_POPOVER.SUBTITLE_INCIDENTS',
    description: 'FILE_UPLOAD_POPOVER.DESC_INCIDENTS',
    fileTypes: `(${DOC_SET})`
  },
  DOCGENERATOR: {
    accept: '.zip,.tar.gz',
    maxSize: 200,
    multiple: false,
    title: 'FILE_UPLOAD_POPOVER.TITLE_DOCGENERATOR',
    subtitle: 'FILE_UPLOAD_POPOVER.SUBTITLE_DOCGENERATOR',
    description: 'FILE_UPLOAD_POPOVER.DESC_DOCGENERATOR',
    fileTypes: '(.zip, .tar.gz)'
  },
  DATAMANAGER: {
    accept: '.sql,.ddl,.json,.csv,.txt,.er',
    maxSize: 50,
    multiple: true,
    title: 'FILE_UPLOAD_POPOVER.TITLE_DATAMANAGER',
    subtitle: 'FILE_UPLOAD_POPOVER.SUBTITLE_DATAMANAGER',
    description: 'FILE_UPLOAD_POPOVER.DESC_DATAMANAGER',
    fileTypes: '(.sql, .ddl, .json, .csv, .txt, .er)'
  }
} as const;

export type UploadType = keyof typeof UPLOAD_CONFIGS;
